/**
 * Точка входа для бренд-конфига. Активный бренд резолвится на этапе сборки
 * по NEXT_PUBLIC_BRAND (через сгенерированный ./active-brand.generated.ts),
 * поэтому в бандл попадает ТОЛЬКО конфиг текущего бренда — это гарантирует,
 * что в сборку skufpro не утекут «vpn»-строки из других конфигов.
 *
 * Файл active-brand.generated.ts создаётся scripts/prepare-brand.mjs
 * (хуки postinstall / prebuild / predev).
 */
import { brand } from './active-brand.generated'

export type { BrandConfig, BrandId, BrandCopy, BrandSocial } from './brand.types'
export { brand }
export default brand
